import React, { useCallback, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './EmailVerify.scss';
import { verifyEmail } from 'services/emailService';
import { buildEmailInputEmailVerifiedPath, buildEmailLinkExpiredPath } from 'utils/pathBuilder';
import { useSession } from 'context/SessionContext';
import { SessionDTO } from 'types/dto/login';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const EmailVerify: React.FC = () => {
  const { t } = useTranslation('email_verify');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('verify_token');
  const { session, setSession } = useSession();

  const hasVerified = useRef(false);

  const verifyEmailWithToken = useCallback(
    async (token: string) => {
      if (hasVerified.current) return;
      hasVerified.current = true;

      try {
        const result: any = await verifyEmail(token);
        // console.log('Email verified:', result);

        // Email Verify
        if (result.access_token && result.refresh_token) {
          setSession({
            ...session,
            _tk: result.access_token,
            _rt: result.refresh_token,
          } as SessionDTO);

          navigate(buildEmailInputEmailVerifiedPath());
        }
      } catch (error) {
        navigate(buildEmailLinkExpiredPath());
      }
    },
    [navigate],
  );

  useEffect(() => {
    if (token) {
      verifyEmailWithToken(token);
    }
  }, [token, verifyEmailWithToken]);

  return (
    <div className="email-verify-container">
      {token && (
        <div className="email-verify-loading">
          <Spin size="large" />
          <div>{t('verifying')}</div>
        </div>
      )}
    </div>
  );
};

export default EmailVerify;
